const parseBoolean = (value, fallback) => {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  const normalized = String(value).trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }

  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }

  return fallback;
};

const parseInteger = (value, fallback, { min, max } = {}) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  const rounded = Math.round(parsed);
  if (Number.isFinite(min) && rounded < min) {
    return min;
  }

  if (Number.isFinite(max) && rounded > max) {
    return max;
  }

  return rounded;
};

// Default loop interval for pending alarm playback.
const DEFAULT_LOOP_INTERVAL_MS = 1 * 60 * 1000;

const ENV =
  (typeof import.meta !== 'undefined' && import.meta.env) ||
  (typeof process !== 'undefined' && process.env) ||
  {};

export const ALARM_PLAYBACK_CONFIG = Object.freeze({
  // Re-announce active unsilenced alarms until they are acknowledged/silenced.
  loopEnabled: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_LOOP_ENABLED, true),
  loopIntervalMs: parseInteger(
    ENV.PUBLIC_ALARM_PLAYBACK_LOOP_INTERVAL_MS,
    DEFAULT_LOOP_INTERVAL_MS,
    {
      min: 15 * 1000,
      max: 60 * 60 * 1000,
    },
  ),
  announceOnRefresh: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_ANNOUNCE_ON_REFRESH, true),
  replayOnUnsilence: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_REPLAY_ON_UNSILENCE, true),
  interruptCurrentSpeech: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_INTERRUPT_CURRENT_SPEECH, true),
  skipWhenSpeechBusy: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_SKIP_WHEN_BUSY, false),
  headingText: ENV.PUBLIC_ALARM_PLAYBACK_HEADING_TEXT ?? 'Pending Alarms',
  maxMessagesPerCycle: parseInteger(ENV.PUBLIC_ALARM_PLAYBACK_MAX_MESSAGES_PER_CYCLE, 25, {
    min: 1,
    max: 200,
  }),

  // Fields spoken per alarm — set to true to include, false to omit.
  announcementFields: Object.freeze({
    headline: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_HEADLINE, true),
    alertType: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_ALERT_TYPE, true),
    // source:     parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_SOURCE,      false),
    // device:     parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_DEVICE,      false),
    // message:    parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_MESSAGE,     false),
    // location:   parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_LOCATION,    false),
    // severity:   parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_SEVERITY,    false),
    // startTime:  parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_START_TIME,  false),
    // expireTime: parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_EXPIRE_TIME, false),
    // nwsOffice:  parseBoolean(ENV.PUBLIC_ALARM_PLAYBACK_FIELD_NWS_OFFICE,  false),
  }),
});
